import { generateNameSuggestionSuffix } from '@bingads-webui-campaign/audience-campaign-shared';
import { DeviceKeys } from '@bingads-webui-campaign-react/xandr-campaign';

export const BiddingSchemes = {
  EnhancedCpc: 'EnhancedCpc',
  MaxConversions: 'MaxConversions',
  ManualCpm: 'ManualCpm',
  ManualCpV: 'ManualCpv',
};

export const BidTypes = {
  SearchBid: 'SearchBid',
  CpmBid: 'CpmBid',
  CpvBid: 'CpvBid',
};

export const BiddingSchemeToBidType = {
  EnhancedCpc: BidTypes.SearchBid,
  ManualCpc: BidTypes.SearchBid,
  ManualCpm: BidTypes.CpmBid,
};

export const BudgetTypes = {
  DailyStandard: 'DailyStandard',
  LifetimeBudgetStandard: 'LifetimeBudgetStandard',
};


export const PriceModelToRange = {
  EnhancedCpc: 'KeywordBidRange',
  ManualCpc: 'KeywordBidRange',
  ManualCpv: 'KeywordCPVBidRange',
  ManualCpm: 'KeywordCPMBidRange',
};

export const AgeRanges = {
  EighteenToTwentyFive: 'EighteenToTwentyFive',
  TwentyFiveToThirtyFive: 'TwentyFiveToThirtyFive',
  ThirtyFiveToFifty: 'ThirtyFiveToFifty',
  FiftyToSixtyFive: 'FiftyToSixtyFive',
  SixtyFiveAndAbove: 'SixtyFiveAndAbove',
  Unknown: 'Unknown',
};

export const GenderTypes = {
  Female: 'Female',
  Male: 'Male',
  Unknown: 'Unknown',
};

export const DeviceTypes = {
  Computers: DeviceKeys.Computers,
  Tablets: DeviceKeys.Tablets,
  Smartphones: DeviceKeys.Smartphones,
};

export const getInitialAdGroupData = ({ i18n }) => ({
  Status: 'Active',
  Name: generateNameSuggestionSuffix(i18n.getString(_TL_('Ad group'))),
  locationTargets: {
    bidMode: false,
    currentLevelSettings: {
      initLocations: [],
      peopleInLocation: true,
      peopleSearchingForLocation: true,
      targetOption: 'everywhere',
    },
    parentLevelSettings: {},
    useParentLevel: false,
  },
  adSchedules: {
    adScheduleUseSearcherTimeZone: undefined,
    dayTimeRanges: [],
    timeZone: undefined,
  },
});

export const getInitialAdData = ({ i18n }) => ({
  Status: 'Active',
  Name: generateNameSuggestionSuffix(i18n.getString(_TL_('Ad'))),
  locationTargets: {
    bidMode: false,
    currentLevelSettings: {
      initLocations: [],
      peopleInLocation: true,
      peopleSearchingForLocation: true,
      targetOption: 'everywhere',
    },
    parentLevelSettings: {},
    useParentLevel: false,
  },
  adSchedules: {
    adScheduleUseSearcherTimeZone: undefined,
    dayTimeRanges: [],
    timeZone: undefined,
  },
  images: {

  },
});

export const AdGroupCriterions = {
  0: {
    Criterion: {
      BidAdjustment: 0,
      DayTimeCriterion: {
        Id: '',
        Day: 'Sunday',
        FromHour: 0,
        FromMinute: 0,
        ToHour: 24,
        ToMinute: 0,
      },
      Type: 'DayTime',
    },
    CriterionType: 'DayTime',
    Id: '',
  },
  1: {
    Criterion: {
      BidAdjustment: 0,
      DayTimeCriterion: {
        Id: '',
        Day: 'Monday',
        FromHour: 0,
        FromMinute: 0,
        ToHour: 24,
        ToMinute: 0,
      },
      Type: 'DayTime',
    },
    CriterionType: 'DayTime',
    Id: '',
  },
  2: {
    Criterion: {
      BidAdjustment: 0,
      DayTimeCriterion: {
        Id: '',
        Day: 'Tuesday',
        FromHour: 0,
        FromMinute: 0,
        ToHour: 24,
        ToMinute: 0,
      },
      Type: 'DayTime',
    },
    CriterionType: 'DayTime',
    Id: '',
  },
  3: {
    Criterion: {
      BidAdjustment: 0,
      DayTimeCriterion: {
        Id: '',
        Day: 'Wednesday',
        FromHour: 0,
        FromMinute: 0,
        ToHour: 24,
        ToMinute: 0,
      },
      Type: 'DayTime',
    },
    CriterionType: 'DayTime',
    Id: '',
  },
  4: {
    Criterion: {
      BidAdjustment: 0,
      DayTimeCriterion: {
        Id: '',
        Day: 'Thursday',
        FromHour: 0,
        FromMinute: 0,
        ToHour: 24,
        ToMinute: 0,
      },
      Type: 'DayTime',
    },
    CriterionType: 'DayTime',
    Id: '',
  },
  5: {
    Criterion: {
      BidAdjustment: 0,
      DayTimeCriterion: {
        Id: '',
        Day: 'Friday',
        FromHour: 0,
        FromMinute: 0,
        ToHour: 24,
        ToMinute: 0,
      },
      Type: 'DayTime',
    },
    CriterionType: 'DayTime',
    Id: '',
  },
  6: {
    Criterion: {
      BidAdjustment: 0,
      DayTimeCriterion: {
        Id: '',
        Day: 'Saturday',
        FromHour: 0,
        FromMinute: 0,
        ToHour: 24,
        ToMinute: 0,
      },
      Type: 'DayTime',
    },
    CriterionType: 'DayTime',
    Id: '',
  },
};

export const BundleLocationCriterions = [
  {
    Status: 'Active',
    SelectionStatus: 'Included',
    Campaign: null,
    CriterionType: 'Location',
    Criterion: {
      Type: 'Location',
      BidAdjustment: 0,
      OriginalBidAdjustment: 0,
      LocationCriterion: {
        LocationId: 32,
        Name: 'Canada',
        NameTypeCombo: 'Canada (country/region)',
        Latitude: 62.5724,
        Longitude: -96.5672,
        CountryCode: 'CA',
        LocationType: 'Country',
        EnclosingLocationIds: [],
        Type: 'Location',
        LesLocationType: 'Country',
      },
    },
  },
  {
    Status: 'Active',
    SelectionStatus: 'Included',
    Campaign: null,
    CriterionType: 'Location',
    Criterion: {
      Type: 'Location',
      BidAdjustment: 0,
      OriginalBidAdjustment: 0,
      LocationCriterion: {
        LocationId: 190,
        Name: 'United States',
        NameTypeCombo: 'United States (country/region)',
        Latitude: 39.5036,
        Longitude: -99.0183,
        CountryCode: 'US',
        LocationType: 'Country',
        EnclosingLocationIds: [],
        Type: 'Location',
        LesLocationType: 'Country',
      },
    },
  },
];

export const BundleCountries = [
  {
    Country: 'Canada',
    LocationId: 32,
  },
  {
    Country: 'US',
    LocationId: 190,
  },
];

export const AdPreviewOverideStylesByKey = {
  mma_191x100: { imagePreviewHeight: 153, imagePreviewWidth: 292 },
  edge_178x100: { imagePreviewHeight: 220, imagePreviewWidth: 390 },
  msan_191x100: { imagePreviewHeight: 200, imagePreviewWidth: 382 },
  msan_150x100: { imagePreviewHeight: 200, imagePreviewWidth: 300 },
};

const CampaignGoal = {
  ConvertCustomers: 'ConvertCustomers',
  Consideration: 'Consideration',
  BrandAwareness: 'BrandAwareness',
  SellProducts: 'SellProducts',
  PromoteApp: 'PromoteMyApp',
  SkipGoals: 'SkipGoals',
  NoneSelected: 'None',
};

export const CampaignObjectiveType = {
  Unknown: 'Unknown',
  Acquisition: 'Acquisition',
  Engagement: 'Engagement',
  Awareness: 'Awareness',
};

export const getActualGoalFromCampaignGoal = (goal) => {
  switch (goal) {
    case CampaignGoal.ConvertCustomers:
      return CampaignObjectiveType.Acquisition;
    case CampaignGoal.Consideration:
      return CampaignObjectiveType.Engagement;
    case CampaignGoal.BrandAwareness:
      return CampaignObjectiveType.Awareness;
    case CampaignGoal.SellProducts:
      return CampaignObjectiveType.Acquisition;
    case CampaignGoal.PromoteApp:
      return CampaignObjectiveType.Acquisition;
    default:
      return CampaignObjectiveType.Unknown;
  }
};
